export const clientUrl = "project-seed-339203.firebaseapp.com";
